// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from "stimulus";
var data = "";
export default class extends Controller {
  static targets = ["modal", "modalWrapper", "template", "cancelled"];

  initialize() {}
  connect() {
    //getting all data in form
    data = $("form").serialize();

    const modalWrapper = document.querySelector(".modal-wrapper");
    document.addEventListener("keydown", (e) => {
      if (e.key == "Escape" && !modalWrapper.classList.contains("inactive")) {
        const formChange = document.getElementById("formChange");
        var currState = formChange
          ? formChange.textContent == "changed"
          : false;
        if (
          !confirm(
            currState ? "שינויים שלא נשמרו, האם לסגור?" : "אם בטוח לצאת?"
          )
        )
          return;
        modalWrapper.classList.add("inactive");
        this.removeEventParam();

        setTimeout(() => {
          console.log(12);

          modalWrapper.style.display = "none";
          document.body.style.overflow = "auto";
        }, 200);
      }
    });
    modalWrapper.addEventListener("click", (e) => {
      const formChange = document.getElementById("formChange");
      var currState = formChange ? formChange.textContent == "changed" : false;
      if (
        e.target == modalWrapper &&
        !modalWrapper.classList.contains("inactive") &&
        confirm(currState ? "שינויים שלא נשמרו, האם לסגור?" : "אם בטוח לצאת?")
      ) {
        console.log(e);
        modalWrapper.classList.add("inactive");
        this.removeEventParam();
        setTimeout(() => {
          console.log(12);

          this.modalWrapperTarget.style.display = "none";
          document.body.style.overflow = "auto";
        }, 200);
      }
    });

    var containers = document.querySelectorAll(".availability");
    var event = new Event("refresh");

    let preUrl = "";
    const observer = new MutationObserver(function (mutations) {
      if (window.location.href !== preUrl) {
        preUrl = window.location.href;
        console.log(`URL changed from ${preUrl} to ${window.location.href}`);
        document.addEventListener("DOMContentLoaded", (event) => {
          containers.forEach((cont) => {
            cont.dispatchEvent(event);
          });
        });
      }
    });
    const config = { subtree: true, childList: true };

    // start listening to changes
    observer.observe(document, config);
  }
  add(e) {
    const modal = this.modalTarget;
    modal.style.display = "initial";
    modal.querySelector("#day").innerHTML = e.target.dataset.date;
  }

  open(e) {
    data = $("form").serialize();
    let event = "";
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);
    if (e.target.dataset.event)
      event = e.target.dataset.event;
    else if (e.target.parentElement.dataset.event)
      event = e.target.parentElement.dataset.event;
    url.searchParams.set("event", event);

    if (document.querySelector(".full_screen_button"))
      document.querySelector(".full_screen_button").dataset.event = event;

    // Show the modal
    this.modalWrapperTarget.classList.remove("inactive");

    window.history.pushState("", "", url);

    // The event body arrives later through the Calendar#event reflex. Show a
    // loading placeholder meanwhile (instead of a blank/stale modal) and, if the
    // reflex never delivers, load the page with ?event=ID, which renders the
    // event server-side - the same thing a manual refresh used to do.
    const content = document.getElementById("calendar-modal-content");
    if (content && event) {
      content.innerHTML = '<div class="calendar-modal-loading">טוען אירוע...</div>';
      clearTimeout(this.loadFallbackTimer);
      this.loadFallbackTimer = setTimeout(() => {
        if (content.querySelector(".calendar-modal-loading")) {
          window.location.href = url.toString();
        }
      }, 8000);
    }
    
    // Open the modal wrapper
    const modalWrapper = this.modalWrapperTarget;
    modalWrapper.style.display = "initial";
    modalWrapper.classList.remove("inactive");
    document.body.style.overflow = "hidden";
  }
  full_screen(e) {
    let event = "new";
    if (e.currentTarget.dataset.event)
      event = e.currentTarget.dataset.event + "/edit";
    else if (e.currentTarget.parentElement.dataset.event)
      event = e.currentTarget.parentElement.dataset.event + "/edit";
    let url = "/events/" + event;
    console.log(url);
    window.open(url, "_blank").focus();
  }
  open_note_modal(e) {
    e.preventDefault(); // Prevent any default behavior
    const date = e.currentTarget.dataset.date;

    // Open the modal wrapper
    const modalWrapper = this.modalWrapperTarget;
    modalWrapper.style.display = "initial";
    modalWrapper.classList.remove("inactive");
    document.body.style.overflow = "hidden";

    this.stimulate("CalendarReflex#open_note_modal", date);
  }

  desk_classrooms_info(e) {
    // Open the modal wrapper first
    const modalWrapper = this.modalWrapperTarget;
    modalWrapper.style.display = "initial";
    modalWrapper.classList.remove("inactive");
    document.body.style.overflow = "hidden";
  }

  close() {
    const formChange = document.getElementById("formChange");
    var currState = formChange ? formChange.textContent == "changed" : false;
    if (
      currState &&
      !confirm(currState ? "שינויים שלא נשמרו, האם לסגור?" : "אם בטוח לצאת?")
    )
      return;
    this.removeEventParam();
    const modal = this.modalWrapperTarget;
    modal.classList.add("inactive");

    // Clear cached event data from fullscreen element
    const fullscreenEl = document.querySelector(".days_calendar_modal .fullscreen");
    if (fullscreenEl) {
      fullscreenEl.dataset.event = "";
    }

    setTimeout(() => {
      console.log(12);

      modal.style.display = "none";
      document.querySelector("#calendar-modal-content").innerHTML = "";
      document.body.style.overflow = "auto";
    }, 200);
  }
  
  cancelled(e) {
    const cancelled = document.querySelectorAll(".cancelled");
    cancelled.forEach((e) => {
      e.classList.toggle("hidden");
    });
    e.target.classList.toggle("rotate");
  }
  notcancelled(e) {
    const cancelled = document.querySelectorAll(".notcancelled");
    cancelled.forEach((e) => {
      e.classList.toggle("hidden");
    });
    e.target.classList.toggle("rotate");
  }
  hover(e) {
    const event = e.target.closest(".event").dataset.event;
    document
      .querySelectorAll(`button[data-event='${event}']`)
      .forEach((btn) => {
        btn.classList.toggle("hover");
      });

    const options = {
      root: document.querySelector(".table-wrapper"),
      rootMargin: "0px",
      threshold: 0,
    };
    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (entry.boundingClientRect.right > entry.rootBounds.right) {
            entry.target.style.right = "1rem";
            entry.target.style.left = "unset";
          }
          if (entry.boundingClientRect.left < entry.rootBounds.left) {
            entry.target.style.left = "1rem";
            entry.target.style.right = "unset";
          }
          if (entry.boundingClientRect.top < entry.rootBounds.top) {
            entry.target.style.top = "1rem";
            entry.target.style.bottom = "unset";
          }
          if (entry.boundingClientRect.bottom > entry.rootBounds.bottom) {
            entry.target.style.bottom = "1rem";
            entry.target.style.top = "unset";
          }
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);

    const target = e.target
      .closest(".event-panel")
      .querySelector(".hover-info");
    observer.observe(target);
  }
  choose(e) {
    const date = e.target.value;
    const url = new URL(window.location.href);
    console.log(url);
    const params = new URLSearchParams(url.search);
    url.searchParams.set("start_date", date);
    if (e.target.dataset.time == "week") {
      url.searchParams.set("t", "week");
    } else {
      url.searchParams.set("t", "month");
    }
    // params.set("start_date", date)
    console.log(url);
    window.location.href = url;
  }

  toggleColor() {
    const buttons = document.querySelectorAll(".choose-color");
    buttons.forEach((e) => {
      e.classList.toggle("rand");
    });
  }
  removeEventParam() {
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);
    params.delete("event");
    window.history.pushState(
      "",
      "",
      window.location.href.split("?")[0] + "?" + params
    );
  }  
}

// "Sent to customer" toggle of the coordinator form (event page and calendar popup).
// Called from the button's onclick, updates the status in place - no page reload.
window.toggleCoordinatorSent = function (button) {
  const sent = button.dataset.sent === "true";
  const url = sent ? button.dataset.unmarkUrl : button.dataset.markUrl;
  const box = button.closest(".coordinator-share");
  button.disabled = true;
  fetch(url, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
    },
  })
    .then((response) => {
      if (!response.ok) throw new Error("toggle failed");
      return response.json();
    })
    .then((data) => {
      button.dataset.sent = data.sent;
      button.textContent = data.sent ? "בטל סימון שליחה" : "סמן כנשלח ללקוח";
      button.classList.toggle("btn-secondary", data.sent);
      button.classList.toggle("btn-primary", !data.sent);
      box.querySelector(".coordinator-share__label").textContent = data.label;
      box.querySelector(".coordinator-share__sent-at").textContent = data.sent_at ? `(נשלח ב-${data.sent_at})` : "";
      const buildIcon = () => {
        const icon = document.createElement("span");
        icon.className = "material-icons coordinator-status-icon";
        return icon;
      };
      const applyIcon = (holder) => {
        let icon = holder.querySelector(".coordinator-status-icon");
        if (!data.icon) {
          if (icon) icon.remove();
          return;
        }
        if (!icon) {
          icon = buildIcon();
          holder.appendChild(icon);
        }
        icon.textContent = data.icon;
        icon.style.color = data.color;
        icon.dataset.tooltip = data.label;
        icon.setAttribute("aria-label", data.label);
      };

      // status line in the form tab
      applyIcon(box.querySelector(".coordinator-share__icon"));

      // and the icon next to the event name on the calendar behind the popup (only where the name is shown)
      const eventId = box.dataset.eventId;
      document.querySelectorAll(`button.event-${eventId} > span`).forEach((nameSpan) => {
        const hasName = Array.from(nameSpan.childNodes).some(
          (n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim() !== ""
        );
        if (hasName) applyIcon(nameSpan);
      });
    })
    .catch(() => alert("שגיאה בעדכון סימון השליחה, נסו שוב"))
    .finally(() => {
      button.disabled = false;
    });
  return false;
};

// Hover tooltip for the coordinator form status icon. One floating element on <body>, so it is not
// clipped by the calendar's scrolling container (the icon sits at the edge of the Sunday column).
(function () {
  if (window.__coordinatorTooltipReady) return;
  window.__coordinatorTooltipReady = true;

  const tooltip = () => {
    let el = document.getElementById("coordinator-status-tooltip");
    if (!el) {
      el = document.createElement("div");
      el.id = "coordinator-status-tooltip";
      document.body.appendChild(el);
    }
    return el;
  };

  document.addEventListener("mouseover", (e) => {
    const icon = e.target.closest && e.target.closest(".coordinator-status-icon");
    if (!icon || !icon.dataset.tooltip) return;
    const el = tooltip();
    el.textContent = icon.dataset.tooltip;
    el.style.display = "block";
    const r = icon.getBoundingClientRect();
    const w = el.offsetWidth;
    const left = Math.min(Math.max(8, r.left + r.width / 2 - w / 2), window.innerWidth - w - 8);
    el.style.left = `${left}px`;
    el.style.top = `${Math.max(8, r.top - el.offsetHeight - 6)}px`;
  });

  document.addEventListener("mouseout", (e) => {
    const icon = e.target.closest && e.target.closest(".coordinator-status-icon");
    if (!icon) return;
    const el = document.getElementById("coordinator-status-tooltip");
    if (el) el.style.display = "none";
  });
})();

// Copy button next to the coordinator form's public link
window.copyCoordinatorLink = function (button) {
  const input = button.closest(".coordinator-share").querySelector(".coordinator-share__link");
  const label = button.querySelector("span");
  const done = () => {
    label.textContent = "הועתק ✓";
    setTimeout(() => {
      label.textContent = "העתק";
    }, 1800);
  };
  const fallback = () => {
    input.select();
    input.setSelectionRange(0, input.value.length);
    try {
      document.execCommand("copy") ? done() : alert("לא ניתן להעתיק אוטומטית, העתיקו ידנית");
    } catch (e) {
      alert("לא ניתן להעתיק אוטומטית, העתיקו ידנית");
    }
  };
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(input.value).then(done, fallback);
  } else {
    fallback();
  }
  return false;
};
